<template>
  <div
    style="mask-size: 100% 100%"
    :style="{
      'mask-image': `url('${maskDataUrl}')`,
      '-webkit-mask-image': `url('${maskDataUrl}')`,
    }"
  >
    <ImgComponent
      style="opacity: 0 !important"
      :src="src"
      :fallback="fallback"
      @pictureUrlSelected="newUrl => (urlToUse = newUrl)"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ImgComponent from './ImgComponent.vue'

export default defineComponent({
  name: 'HomeBottomNavs',
  components: { ImgComponent },
  props: {
    src: { type: String, default: '' },
    fallback: { type: String, default: '' },
  },
  data() {
    return {
      urlToUse: this.src,
    }
  },
  computed: {
    maskDataUrl() {
      return this.normalizeToBase64(this.urlToUse)
    },
  },
  methods: {
    normalizeToBase64(str) {
      if (!str) return ''

      // 1) Si c'est déjà une data:...;base64, on renvoie tel quel
      if (/^data:.*;base64,/.test(str)) return str

      // 2) Si c'est une data:image/svg+xml, (percent-encoded) -> convertir en base64
      const percentSvg = str.match(/^data:image\/svg\+xml,([\s\S]*)$/i)
      if (percentSvg) {
        const payload = percentSvg[1]
        let decoded
        try {
          decoded = decodeURIComponent(payload)
        } catch (e) {
          // si l'URI est mal formée, on garde la payload brute
          decoded = payload
        }
        return this._toBase64DataSvg(decoded)
      }

      // 3) Cas data:image/svg+xml;... (ex: charset) suivi de contenu non-base64
      const dataSvgWithParams = str.match(
        /^data:image\/svg\+xml;(?:[^,]*,)([\s\S]*)$/i,
      )
      if (dataSvgWithParams) {
        let payload = dataSvgWithParams[1]
        try {
          // payload peut être percent-encoded ou brut
          payload =
            payload.indexOf('%') !== -1 ? decodeURIComponent(payload) : payload
        } catch (e) {
          // ignore
        }
        return this._toBase64DataSvg(payload)
      }

      // 4) Si c'est une URL normale (http/https ou chemin) -> renvoyer tel quel
      if (/^(https?:\/\/|\/|\.\/|\.\.\/)/.test(str)) return str

      // 5) Sinon on suppose que c'est du SVG brut (XML) -> encoder en base64
      return this._toBase64DataSvg(str)
    },

    // helper: encode string SVG (Unicode-safe) en data:image/svg+xml;base64,...
    _toBase64DataSvg(svgString) {
      // Utilise TextEncoder pour gérer correctement les caractères non ASCII
      const encoder = new TextEncoder()
      const bytes = encoder.encode(svgString)
      let binary = ''
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      const base64 = btoa(binary)
      return `data:image/svg+xml;base64,${base64}`
    },
  },
})
</script>
